export default __webpack_public_path__ + "static/media/img_baseBunny_lemon_p.c8885e48.jpg";